<template>
  <div>
    <div class="title">
      <a-card v-for="(item,index) in cardList" :key="index" class="card">
        <div class="disFlex">
          <div class="left">
            <span>{{ item.title }}</span>
            <span></span>
            <span>{{ item.desc }}</span>
          </div>
          <div class="right">
            <img :src="item.iconSrc" alt="icon">
          </div>
        </div>
      </a-card>
    </div>
    <div class="mrtop10 card-container">
      <div id="echarts1" :style="{width: '100%', height: '320px'}"></div>
    </div>
    <div class="card-container">
      <div id="echarts2" :style="{width: '100%', height: '320px'}"></div>
    </div>
  </div>
</template>

<script>
import { EleResize } from '@/utils/esresize.js'
import * as echarts from 'echarts'
import { iconFontComponent } from '@/components/mixins/mixins.js'
import { getDataOperatingCost } from '@/api/statistics'
export default {
  mixins: [iconFontComponent],
  data () {
    return {
      deliver_myCharts: null,
      operation_myCharts: null,
      cardList: [
        {
          title: '监管成本提高',
          desc: '数字化管理',
          iconSrc: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210430/16197610447681d024b461b954eeaadb88b539f399e02.png'
        },
        {
          title: '工作积极性提高',
          desc: '奖惩机制提高运营工作积极性',
          iconSrc: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210430/1619761061012691bc4f879c147b4bfbd021f3b278b8c.png'
        },
        {
          title: '设备维护成本',
          desc: '及时发现/解决问题',
          iconSrc: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210430/16197611579443a764726cc6f44acac4a8a6916e6ae36.png'
        }
      ],
      dateList: [],
      operationList: [],
      deliverList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    getData () {
      getDataOperatingCost({}).then((res) => {
        const result = res.result
        const dateList = []
        const operationList = []
        const deliverList = []
        result.forEach(element => {
          dateList.push(element.day)
          operationList.push(element.operatorCost)
          deliverList.push(element.inspectCost)
        })
        this.dateList = dateList
        this.operationList = operationList
        this.deliverList = deliverList
        this.$nextTick(() => {
          setTimeout(() => {
            this.operationEchart()
            this.deliverEchart()
          }, 50)
        })
      })
    },
    operationEchart () {
      if (operation_myCharts != null && operation_myCharts !== '' && operation_myCharts !== undefined) {
        operation_myCharts.dispose()
      }
      const chartDom = document.getElementById('echarts1')
      const operation_myCharts = echarts.init(chartDom)
      const option = {
        grid: {
          left: 45,
          right: 25
        },
        title: {
          text: '运营成本提升情况'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let str = '<span style="display:inline-block;margin-right:7px;width:3px;height:15px;left:5px;background-color:' + params[0].color + '"></span>' + params[0].name + '<br />'
            str += '<span style="margin-left:10px;">' + '运营成本提升' + '  ' + '<span style="color:#24D5E1;font-size:15px;font-weight:600">' + params[0].data + '%' + '</span>' + '</span>'
            return str
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dateList,
          axisLabel: {
            interval: 6
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.operationList,
          type: 'line',
          smooth: true,
          itemStyle: {
            color: '#24D5E1'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                { offset: 0, color: '#35e7f3' },
                { offset: 0.3, color: 'rgba(9,232,247, 0.5)' },
                { offset: 1, color: 'rgba(255, 255, 255, 0.1)' }
              ]
            ),
            borderColor: '#24D5E1',
            borderWidth: 2
          }
        }]
      }
      const listener = function () {
        operation_myCharts.resize()
      }
      // window.addEventListener('resize', listener)
      EleResize.on(document.getElementById('echarts1'), listener)
      operation_myCharts.setOption(option)
    },
    deliverEchart () {
      if (deliver_myCharts != null && deliver_myCharts !== '' && deliver_myCharts !== undefined) {
        deliver_myCharts.dispose()
      }
      const chartDom = document.getElementById('echarts2')
      const deliver_myCharts = echarts.init(chartDom)
      const option = {
        grid: {
          left: 45,
          right: 25
        },
        title: {
          text: '投递监管成本提升情况'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let str = '<span style="display:inline-block;margin-right:7px;width:3px;height:15px;left:5px;background-color:' + params[0].color + '"></span>' + params[0].name + '<br />'
            str += '<span style="margin-left:10px;">' + '投递监管成本提升' + '  ' + '<span style="color:#A796F9;font-size:15px;font-weight:600">' + params[0].data + '%' + '</span>' + '</span>'
            return str
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dateList,
          axisLabel: {
            interval: 6
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.deliverList,
          type: 'line',
          smooth: true,
          itemStyle: {
            color: '#A796F9'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                { offset: 0, color: '#A796F9' },
                { offset: 0.3, color: 'rgba(182,168,249, 0.3)' },
                { offset: 1, color: 'rgba(213,205,251, 0.1)' }
              ]
            ),
            borderColor: '#A796F9',
            borderWidth: 2
          }
        }]
      }
      const listener = function () {
        deliver_myCharts.resize()
      }
      // window.addEventListener('resize', listener)
      EleResize.on(document.getElementById('echarts2'), listener)
      deliver_myCharts.setOption(option)
    }
  }
}
</script>

<style  lang="stylus" scoped>
.title
  display flex
  justify-content space-between
  .card
    width 32%
    .ant-card-body
      padding 20px
      .disFlex
        display flex
        align-items center
        justify-content center
        .left
          display flex
          flex-direction column
          span:nth-child(1)
            font-size 18px
          span:nth-child(2)
            width 25px
            height 3px
            background-color #1890fffa
            margin 15px 0
          span:nth-child(3)
            font-size 14px
            font-weight 500
            color gray
        .right
          margin-left 10px
          img
            // width 80%
.mrtop10
  box-shadow 0px 10px 20px 0px #cdd8e373
  margin-top 10px
.mrtop20
  box-shadow 0px 10px 20px 0px #cdd8e373
  margin-top 20px
</style>
